export default {
	init() {

		function LightListLoop( container ) {

			var items = container.querySelectorAll('.list__single');
			var counter = 0;
			var counterMax = items.length;

			var intervalTime = 1500;
			var interval;

			function NextItem() {

				counter += 1;

				if( counter >= counterMax ) {

					counter = 0;

				}

				items.forEach( function( item, index ) {

					if( index == counter ) {

						item.classList.add('active');

					} else {

						item.classList.remove('active');

					}

				});

			}

			function StartLoop() {

				interval = setInterval(
					function() {

						NextItem();

					},
					intervalTime
				);

			}

			function EndLoop() {

				clearInterval(interval);

			}

			StartLoop();

		}	

		var container = document.querySelectorAll('.lightList');

		if( container.length > 0 ) {

			container.forEach( function( box, index ) {

				LightListLoop( box );

			});

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
